import { Box, Button, makeStyles } from '@material-ui/core';
import React from 'react'
import Modal from "react-awesome-modal";


const useStyles = makeStyles((theme) => ({

  }));
function CheckoutModal(props) {
    const { visible, closeModal } = props;
    const classes = useStyles();
  return (
    <Modal
    width="500"
    visible={true}
    effect="fadeInUp"
    onClickAway={closeModal}
  >
    <div className={classes.modalContainer}>
      <h3 className={classes.modalHeading}>dsfdsfds</h3>
      <hr className={classes.modalLine} />

      <p>
        <b>Per Page Price: </b> 
      </p>
      <p>
        <b>Total Pages: </b>dfdsf
      </p>
      <Box textAlign="right">
        <p>
          <b>Subtotal: </b>
        dsad
        </p>
        <p>
          <b>Tax: </b>
         dsdsad
        </p>
        <h4>TOTALdfdsf</h4>
      </Box>

      <Box mt={5} display="flex" justifyContent="space-between">
        <Button className={classes.cancelBtn} onClick={closeModal}>
          Cancel
        </Button>
        <Button className={classes.submitBtn} >
          Checkout
        </Button>
      </Box>
    </div>
  </Modal>
  )
}
export default CheckoutModal